export default __webpack_public_path__ + "static/media/bg3.b5b50b7c.jpg";